
<Page name="myBookmarks" 
infinite
infiniteDistance={30}
infinitePreloader={showPreloader}
onInfinite={loadMore}
on:resize={() => fResize()}
>
  <Header />
  <div style="margin:20px;"></div>
  <div style="margin-left:16px"><Link href="/">Back to Recommendations by Grade</Link></div>
  <div id="print-rec-list">
    <Row>
      <BlockTitle style="font-size:1.1rem; color:#003d79; letter-spacing: 0.5px; font-weight:400;float:left;">My Recommendation Bookmarks</BlockTitle>
      <!-- <Button large fill style="width:200px; float:right;"
        onClick={() => printDiv('print')}><i class="icon f7-icons">printer</i> Print This List</Button> -->
    </Row>
    <Block>
      <p>* Bookmarked recommendations are stored on the browser rather than on the server, so clearing browsing data or history will result in the removal of the saved filters.</p>
    </Block>
    <div>
      {#if recommendations}
        {#each gradeKeyArr as key}
        <Row>
            <div class="grade-category" style={"background-color:"+key.backgroundColor+"; color:" + key.color}>
            {key.grade} - {key.status} ({recGroupedByGrade[key.grade] && recGroupedByGrade[key.grade].length})</div>
        </Row>
        {#if recommendations.length > 0 && key.grade && recGroupedByGrade[key.grade] && recGroupedByGrade[key.grade].length > 0}
        <div>
          {#each recGroupedByGrade[key.grade] as recommendation, i}
            <RecomendationListItem recommendation={recommendation} generalRec={oData.generalRecommendations[recommendation.general]}/>
          {/each}
        </div>
        {/if}
        {#if !recGroupedByGrade || !recGroupedByGrade[key.grade] || recGroupedByGrade[key.grade].length < 1} 
          <p>There are no recommendations.</p>
        {/if}
        {/each}
        {#if recommendations.length < 1} 
          <p>There are no saved recommendations.</p>
        {/if}
      {:else}
        <div class="preloader-modal" style="background: transparent;">
          <Preloader size={70} color="blue"></Preloader>
        </div>
      {/if} 
    </div>
  </div>
  <div style="margin:20px;"></div>
  <Row><Footer/></Row>
</Page>
  <script>
    import {
      Button,
      Preloader,
      Row,
      Page,
      Block,
      BlockTitle,
      Link
    } from 'framework7-svelte';
    import { onDestroy } from 'svelte';
    import Header from '../components/Header.svelte';
     import Footer from '../components/Footer.svelte';
    import { bIsFilterStore, oFilterStore, searchData, fIsMetric, arrBookmarkedRec, fMyBookmarkedRecData } from '../stores.js';
    import { groupBy, fCalculateBMI, fConvertToFtIn } from '../utils.js';
    import RecomendationListItem from '../components/RecommendationListItem.svelte';
    import {GRADE_KEY_CONST} from '../constants.js';
  
    let page = 1;
    let items;
    let recommendations;
    let recGroupedByGrade;
    let gradeKeyArr;
    let allowInfinite = true;
    let showPreloader = false;
    let oData; 
    let oFilter;
    let isMetric;
    let arrBookmarkedRecommendations = [];
    let grade;
    let isShowFilter = true;
    let isMobile = true;
    // $: showPreloader = (items) ? (items.length < 299) ? true : false : false;
    // $: getSearchData();
    let unsubscribeBookmarkData;
  
    const unsubscribeSearchData = searchData.subscribe(obj => {
      oData = obj;
      // get bookmarked recommendations from stores
      unsubscribeBookmarkData = arrBookmarkedRec.subscribe(arr => {
        arrBookmarkedRecommendations = arr;
        getSearchData(obj, false);
      });
    });
  
    onDestroy(unsubscribeSearchData);
    onDestroy(unsubscribeBookmarkData);
  
    function printDiv(divName) {
      document.getElementById("print-rec-list").classList.add("section-to-print-body");
      window.print();
      document.getElementById("print-rec-list").classList.remove("section-to-print-body");
    }
  
    async function getSearchData(obj) {
      if (!oData) {return;}

      // filtering bookmarked recommendations
      recommendations = oData.specificRecommendations.filter(rec => {
        if (arrBookmarkedRecommendations.indexOf(rec.id) > -1) {
          rec.bookmark = true;
          return true;
        } 
        return false;
      });
    
      // group recommendations by grade
      recGroupedByGrade = recommendations && groupBy(recommendations, 'grade');
      Object.keys(recGroupedByGrade).forEach(key => {
        recGroupedByGrade[key] = recGroupedByGrade[key].sort((a, b) =>a.title.localeCompare(b.title));
      });
  
      // Hardcoded the grade key value as the order from the endpoint are subject to change.
      gradeKeyArr = recGroupedByGrade && Object.keys(recGroupedByGrade);
      gradeKeyArr = gradeKeyArr && gradeKeyArr.sort((a, b) =>a.localeCompare(b));
      gradeKeyArr = GRADE_KEY_CONST.filter(key => gradeKeyArr.includes(key.grade));
    }
  
    function addTextStyle(str) {
      let arr = str.split(':');
      if (arr.length > 1) {
        return `<p><strong>${arr[0]}:</strong> ${arr[1]}</p>`;
      } else {  
        arr = str.split('---');
        return `<p><strong>${arr[0]} ---</strong> ${arr[1]}</p>`;
      }
    }
  
    function loadMore() {
      if (!allowInfinite) return;
      allowInfinite = false;
  
      if (!showPreloader) return;
      
      page += 1;
    }

    function fResize() {
    if (window.innerWidth > 850) {
      isMobile = false;
    } else {
      isMobile = true;
    }
  }

  window.addEventListener("resize", fResize);
  </script>
  <style>
  .grade-category {
    background-color: #beeeb0;
    padding: 5px;
    margin-top: 5px;
    margin-bottom: 10px;
    letter-spacing: 0.3px;
    width: 100%;
    font-weight: bold;
  }
  .button-row {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  </style>